import {createStrokeSVG} from './TEMPLATE'

// tabler: calendar-clock
export const CalendarClock_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M10.5 21h-4.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3',
    'M16 3v4',
    'M8 3v4',
    'M4 11h10',
    'M14 18a4 4 0 1 0 8 0a4 4 0 1 0 -8 0',
    'M18 16.5v1.5l.5 .5',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
